import { DatePipe, isPlatformServer } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  PLATFORM_ID,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import { TranslocoService, TranslocoDirective } from '@ngneat/transloco';
import { TemporaryClosure, WorkingDays } from '@pedix-workspace/utils';
import { ModalDialogComponent } from '@pedix-workspace/angular-ui-modal';
import { IconBanComponent, IconInfoComponent } from '@pedix-workspace/angular-ui-icons';
import { WorkingHoursMessageDetailsComponent } from '@pedix-workspace/pedixapp-shared-catalog';

@Component({
    selector: 'app-working-hours-message',
    templateUrl: './working-hours-message.component.html',
    styleUrls: ['./working-hours-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [DatePipe],
    imports: [
        TranslocoDirective,
        ModalDialogComponent,
        WorkingHoursMessageDetailsComponent,
        IconInfoComponent,
        IconBanComponent,
    ]
})
export class WorkingHoursMessageComponent implements AfterViewInit {
  private platformId = inject(PLATFORM_ID);
  private datePipe = inject(DatePipe);
  private t = inject(TranslocoService);

  @ViewChild('workingHoursDialog') workingHoursDialog;
  @ViewChild('message') messageElement: ElementRef<HTMLElement>;

  @Input() isClosed: boolean;
  @Input() isAboutToClose: boolean;
  @Input() isTemporaryClosed: boolean;
  @Input() workingDays: WorkingDays | null;
  @Input() temporaryClosure: TemporaryClosure;

  hasMessageOverflow = signal(false);

  get isSsr() {
    return isPlatformServer(this.platformId);
  }

  get temporaryClosureMessage() {
    if (this.temporaryClosure?.message) {
      return this.temporaryClosure.message;
    }
    if (this.temporaryClosure?.to) {
      const returnDate = this.datePipe.transform(this.temporaryClosure?.to, 'dd/MM/yy');

      return this.t.translate('workingHours.temporaryClosedDescription', { returnDate });
    }
    return '';
  }

  ngAfterViewInit() {
    if (this.messageElement?.nativeElement) {
      const element = this.messageElement.nativeElement;

      this.hasMessageOverflow.set(element.scrollHeight > element.clientHeight);
    }
  }

  displayWorkingHours() {
    this.workingHoursDialog.open();
  }
}
